export default __webpack_public_path__ + "images/df7877c32a649c6054e8f7a8ece47d89-rules.svg";